<div class="white-box main-black mt-4 p-4 border-radius">
	<h4>
		{{ chartTitle }}
		<app-help-tooltip *ngIf="tooltipKey" [field]="tooltipKey"></app-help-tooltip>
	</h4>

	<sct-charts
		*ngIf="chartData; else noData"
		class="mt-5 d-block"
		[data]="chartData"
		[columnNames]="chartConfig.columnNames"
		[options]="chartConfig.config"
		[formatter]="chartConfig.formatter"
		[formatterType]="chartConfig.formatterType"
		[title]="chartTitle"
		[type]="'LineChart'"
		[height]="500"
		[haveZoom]="haveZoom"
	></sct-charts>

	<ng-template #noData>
		<div class="alert alert-info mt-2">{{'g.no_data_to_show' | translate}}</div>
	</ng-template>
</div>
